import { ORANGE_COLORS as COLORS } from '@junglescout/styles-library';
import { ToggleButtonSizeStyles } from './types';

export const DEFAULT_COLORS = {
  unchecked: COLORS.grey200,
  checked: COLORS.green500,
};

export const TOGGLE_SIZES: ToggleButtonSizeStyles = {
  small: {
    width: '28px',
    height: '16px',
    thumbSize: '12px',
    uncheckedPosition: '2px',
    checkedPosition: '14px',
  },
  default: {
    width: '38px',
    height: '20px',
    thumbSize: '16px',
    uncheckedPosition: '2px',
    checkedPosition: '20px',
  },
  large: {
    width: '60px',
    height: '30px',
    thumbSize: '24px',
    uncheckedPosition: '3px',
    checkedPosition: '33px',
  },
};
